import { Pipe, PipeTransform } from '@angular/core';

import { hasUserProduct } from '../constants/constants';

@Pipe({ name: 'countUserProducts', standalone: true })
export class CountUserProductsPipe implements PipeTransform {
  transform(
    section: string,
    productName: string,
    productList,
    areAllProductsSelected,
    userServiceUserData
  ): number {
    let count = 0;
    if (productList.hasOwnProperty(productName)) {
      for (const product of productList[productName]) {
        if (
          hasUserProduct(
            section,
            areAllProductsSelected,
            userServiceUserData,
            product.id
          )
        ) {
          count++;
        }
      }
    }
    return count;
  }
}
